module.exports = __webpack_public_path__ + "static/media/fælsleg.871e5824.m4a";